import React, { useEffect, useState, useRef } from 'react'
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { useSelector } from 'react-redux';
import { selectData } from '../../../services/store/userSlice';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { timesheetApi, Util } from '../../../services';
import { Dropdown } from 'primereact/dropdown';
import { leaveService } from '../../../services/extensions';
import { Status, LeaveStatus, LeaveStatusCode } from '../../../common/util/constants';
import { useLocation } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { utitService } from '../../../services/util';
import { ViewLeave } from './view-leave';
import properties from '../../../config/environmentProperties';
import { capitalize } from '../../../services/utility/helper';

// Styles
import "react-big-calendar/lib/css/react-big-calendar.css";
import '../styles/user-leave.scss';
import '../styles/team-leaves.scss';


const ManagerTeamLeaves = ({ reportView, duration }) => {
    const localizer = momentLocalizer(moment);
    const [eventsData, setEventsData] = useState([]);

    const userData = useSelector(selectData);
    const { currentEnvironment } = properties;
    const dt = useRef(null);
    const [leaves, setLeaves] = useState([]);
    const [selectedLeave, setSelectedLeave] = useState([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('id');
    const [selStatus, setSelStatus] = useState('REVIEW');
    const [leaveStatuses] = useState(Object.keys(LeaveStatus));
    const [selLeaves, setSelLeaves] = useState({});
    const [viewDialog, setViewDialog] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [action, setAction] = useState('');
    const [rView, setRView] = useState('Grid');
    const [leaveData, setLeaveData] = useState([]);
    const [resourceMap, setResourceMap] = useState([]);
    const [dataDuration, setDataDuration] = useState({ start: null, end: null });

    useEffect(() => {
        if (duration) {
            getLeaves();
            setDataDuration({
                start: moment(duration).startOf('month').toDate(),
                end: moment(duration).endOf('month').toDate()
            })
        }
    }, [duration])

    useEffect(() => {
        getUserInfoBySuperiorIdList();
    }, [])

    const getUserInfoBySuperiorIdList = (param = { "pageNum": 0, "pageSize": 2000 }) => {
        timesheetApi.getUsersBySuperior(param).then((resp) => {
            try {
                const data = resp.data.data;
                const resource = data.map((user, index) => ({
                    resourceId: user.id,
                    resourceTitle: capitalize(user.firstName + " " + user.lastName)
                })
                );
                setResourceMap(resource);
                getLeaves(resource);
            } catch (error) {
                // Error handle
            }
        });
    }


    const getLeaves = (resource) => {
        leaveService.getTeamLeavesByManager(Util.dateParser(duration, 'YYYY-MM-DD')).then(resp => {
            // setLeaves(resp.data.data);
            const resLeaves = [];
            const events = resp.data.data.map(leave => {
                resLeaves.push({ ...leave, ...leave.user, user: undefined });
                const sd = new Date(leave.startDate);
                const ed = new Date(leave.endDate);
                const start = leave.leaveType === 'FD' ? new Date(sd.getFullYear(), sd.getMonth(), sd.getDate(), 0, 0, 0) : sd;
                const end = leave.leaveType === 'FD' ? new Date(ed.getFullYear(), ed.getMonth(), ed.getDate(), 23, 59, 59) : ed;
                return {
                    title: `${LeaveStatusCode[leave.status]} - ${leave.leaveType} - ${capitalize(leave.user.firstName)} ${capitalize(leave.user.lastName)} - ${leave.reasonOfLeave}`,
                    start: start,
                    end: end,
                    absCode: leave.absenceCode,
                    type: leave.leaveType,
                    reason: leave.reasonOfLeave,
                    allDay: true,
                    backgroundColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
                    // resourceId: leave.user.id
                };
            });
            setEventsData(events);
            setLeaveData(events);
            setLeaves(resLeaves);

        });
    };
    const renderAbsenceCode = (rowData, options) => {        
        return (
            <>
                <strong>{rowData?.LeaveAbsenceCode?.code}</strong>
                <em> ({rowData?.LeaveAbsenceCode?.title})</em>
            </>
        );
    }
    const renderAbsenceDuration = (rowData, options) => {       
        return (<>
            <strong>{rowData?.LeaveType?.code}</strong>
            <em> ({rowData?.LeaveType?.title})</em>
        </>)
    }
    const renderReasonOfLeave = (rowData, options) => {
        const reason = rowData.reasonOfLeave || '';
        const txt = reason.substr(0, 200);
        return (<>
            <span className='noet'>{txt}</span>
        </>)
    }
    const viewLeave = (row) => {
        setSelLeaves(row);
        setViewDialog(true);
    }

    const renderActions = (rowData, options) => {
        return (
            <div className='action-column'>
                {rowData.startDate && <Button icon="pi pi-eye" className="p-button-rounded p-button-text" aria-label="Edit" onClick={() => viewLeave(rowData)} />}
            </div>
        )
    }
    const updateLeaves = (e) => {
        setAction(e);
        setShowDialog(true)
    }
    const paginatorTmpl = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (

                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    }
    const paginationLeft = (e) => {
        return (<div className='ess-header-label pt-1'>
            {['REVIEW'].includes(selStatus) && <>
                <Button label="Approve All" disabled={selectedLeave.length === 0} className="p-button-primary p-button-sm ml-2" icon="pi pi-check" onClick={() => updateLeaves('APPROVE')} />
                <Button label="Reject All" disabled={selectedLeave.length === 0} className="p-button-danger p-button-sm ml-2" icon="pi pi-trash" onClick={() => updateLeaves('REJECT')} />
            </>}

        </div>)
    }
    const imageLoadingError = (e, r) => {
        e.target.src = '/assets/images/avtar.png';
    }
    const representativeBodyTemplate = (rowData) => {
        return (<div className='resource grid'>
            <div className='col-4 center'>
                <img src={currentEnvironment.docPath + 'images/' + rowData?.user?.photo} alt={rowData.firstName} style={{ verticalAlign: 'middle' }}
                    tag={currentEnvironment.docPath + 'images/' + rowData.photo}
                    onError={(e) => imageLoadingError(e, rowData)} />
            </div>
            <div className='col-8 name'>
                <span style={{ verticalAlign: 'middle' }} >{rowData.user.firstName} {rowData.user.lastName}</span>
            </div>
        </div>
        )
    }

    const handleSelect = ({ start, end }) => {

        // setNewEvent({ start, end });
        // getAllLeaves();
        // setShowDialog(true);
        // const title = window.prompt("New Event name");
        // if (title)
        //     setEventsData([
        //         ...eventsData,
        //         { start, end, title }
        //     ]);
    };
    const renderResource = (data) => (<div className='grid ess-resource'>
        {/* <pre className='p-5'>{JSON.stringify(data, null, 4)}</pre> */}
        <div className='col-fixed image' >
            <img src={currentEnvironment.docPath + 'images/' + data?.photo} alt={data.firstName} style={{ verticalAlign: 'middle' }}
                tag={currentEnvironment.docPath + 'images/' + data.photo}
                onError={(e) => { e.target.src = '/assets/images/avtar.png' }} />
        </div>
        <div className='col label'>
            <h2 className='m-0'>{data.firstName} {data.lastName} <small>( ECN: <strong>{data.ecn}</strong> )</small></h2>
        </div>
    </div>);
    const filteredLeaves = leaves.filter(leave => {
        const leaveDate = new Date(leave.startDate);
        return leaveDate >= dataDuration.start && leaveDate <= dataDuration.end;
    });
    return (
        <div className='ess-page p-2'>
            <div className='team-leaves'>
                {reportView === 'Grid' ? <>
                    <div className='grid'>
                        <div className='col p-0 pt-2'>
                            <DataTable value={filteredLeaves}
                                rowGroupMode="subheader" groupRowsBy="userId" rowGroupHeaderTemplate={renderResource}
                                dataKey='id' sortMode="single" sortField="userId" sortOrder={0} responsiveLayout="scroll"
                            >
                                {/* <Column field="user.ecn" header="Resource" headerStyle={{ width: '200px' }} bodyStyle={{ width: '200px', verticalAlign: 'middle' }} body={representativeBodyTemplate}></Column> */}
                                <Column header="#" headerStyle={{ width: '3em' }} body={(data, options) => data.id}></Column>
                                <Column field='startDate' header="Date" headerStyle={{ width: '95px' }} body={(r) => (utitService.dateWithMonthConverter(r.startDate))}></Column>
                                <Column field='startDate' header="Day" headerStyle={{ width: '95px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} ></Column>
                                <Column field='absenceCode' header="Absence Code" headerStyle={{ width: '220px' }} body={renderAbsenceCode}></Column>
                                <Column field='leaveType' header="Leave Type" headerStyle={{ width: '130px' }} body={renderAbsenceDuration} ></Column>
                                <Column field='status' header="Status" headerStyle={{ width: '120px' }} body={(r) => (<span className={'status status-' + r.status}>{LeaveStatusCode[r.status]}</span>)}></Column>
                                <Column field='reasonOfLeave' header="Reason Of Leave" ></Column>
                                <Column header="Actions" headerClassName='center-header' headerStyle={{ width: '90px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center' }} body={renderActions} />
                            </DataTable>
                        </div>
                    </div>
                </> : <>
                    <div className='grid'>
                        <div className='col p-0 pt-2'>
                            <Calendar
                                views={["day", "work_week", "month"]}
                                selectable
                                localizer={localizer}
                                defaultDate={new Date()}
                                defaultView="month"
                                events={eventsData}
                                style={{ height: "calc(100vh - 230px)" }}
                                onSelectEvent={(event) => console.log(event.title)}
                                onSelectSlot={handleSelect}
                            />
                        </div>
                    </div>
                </>}

            </div>
            {ViewLeave({ visible: viewDialog, onHide: () => setViewDialog(false), style: { width: '900px' }, leave: selLeaves, header: 'Leave Details' })}
        </div>
    )
}

export default ManagerTeamLeaves